import { ReactNode, useRef } from "react";
import { Box } from "@mui/material";
import Flex from "../../../../../../../components/Flex";

interface ActionableHoverNewProps {
  renderAction?: ReactNode;
  children: ReactNode;
  renderSection?: ReactNode;
}

const ActionableHoverNew = ({
  children,
  renderAction,
  renderSection,
}: ActionableHoverNewProps) => {
  // const [isHoveredEl, setIsHoveredEl] = useState(false);
  const anchorRef = useRef(null);

  return (
    <Flex gap={1} flexDirection={"column"} width={"100%"}>
      <Flex
        ref={anchorRef}
        width={"100%"}
        // onMouseEnter={() => setIsHoveredEl(true)}
        // onMouseLeave={() => setIsHoveredEl(false)}
        justifyContent={"space-between"}
        alignItems={"center"}
        // border={isHoveredEl ? "2px solid #004186" : "2px solid white"}
        bgcolor={"#EAF4FF4D"}
        pl={2}
        borderRadius={1}
        sx={{
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        <Box>{children}</Box>
        <Box sx={{ cursor: "pointer" }}>{renderAction}</Box>
      </Flex>
      {renderSection}
    </Flex>
  );
};

export default ActionableHoverNew;
